import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'woermaCouponCustomer',
  props: {
    couponConfig: {
      type: Object,
      default: function _default() {
        return {
          accountConfig: {
            // 客户配置(当前客户使用的配置)
            woerma_coupon_type_control: '',
            coupon_type: '',
            woerma_coupon_description_control: '',
            coupon_description: ''
          },
          channelConfig: {
            // 渠道配置(默认规则)
            coupon_type: '',
            coupon_description: ''
          },
          couponTypeOptions: []
        };
      }
    },
    edit: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  watch: {
    couponConfig: {
      handler: function handler(newVal) {
        if (newVal) {
          this.handleInit();
        }
      },
      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      coupon_type: '',
      woerma_coupon_type_control: '',
      coupon_description: '',
      woerma_coupon_description_control: '',
      controlOptions: [{
        name: '默认规则',
        id: '0'
      }, {
        name: '个性化',
        id: '1'
      }],
      imgSrc: 'https://res.youlianfuwu.com/voucher/shop/woerma-coupon-tips-01.png',
      imgSrcList: ['https://res.youlianfuwu.com/voucher/shop/woerma-coupon-tips-01.png', 'https://res.youlianfuwu.com/voucher/shop/woerma-coupon-tips-02.png', 'https://res.youlianfuwu.com/voucher/shop/woerma-coupon-tips-03.png']
    };
  },
  computed: {
    isCouponTypeDisabled: function isCouponTypeDisabled() {
      return this.woerma_coupon_type_control == 0;
    },
    isCouponDescriptionDisabled: function isCouponDescriptionDisabled() {
      return this.woerma_coupon_description_control == 0;
    },
    coupon_limit_cat: function coupon_limit_cat() {
      var _this = this;
      var selectedCoupon = this.couponConfig.couponTypeOptions.find(function (item) {
        return item.coupon_type === _this.coupon_type;
      });
      return (selectedCoupon === null || selectedCoupon === void 0 ? void 0 : selectedCoupon.coupon_limit_cat) || '';
    }
  },
  methods: {
    handleInit: function handleInit() {
      var accountConfig = this.couponConfig.accountConfig;
      this.woerma_coupon_type_control = accountConfig.woerma_coupon_type_control;
      this.woerma_coupon_description_control = accountConfig.woerma_coupon_description_control;

      // 根据规则类型/使用说明提示方式 从对应来源（渠道/客户）取值
      this.onChangeCouponTypeControl();
      this.onChangeCouponDescriptionControl();
    },
    onChangeCouponTypeControl: function onChangeCouponTypeControl() {
      var _this$couponConfig = this.couponConfig,
        accountConfig = _this$couponConfig.accountConfig,
        channelConfig = _this$couponConfig.channelConfig;
      if (this.woerma_coupon_type_control == 0) {
        this.coupon_type = channelConfig.coupon_type;
      } else if (this.woerma_coupon_type_control == 1) {
        // 个性化 从账号配置获取
        this.coupon_type = accountConfig.coupon_type;
      }
    },
    onChangeCouponDescriptionControl: function onChangeCouponDescriptionControl() {
      var _this$couponConfig2 = this.couponConfig,
        accountConfig = _this$couponConfig2.accountConfig,
        channelConfig = _this$couponConfig2.channelConfig;
      if (this.woerma_coupon_description_control == 0) {
        this.coupon_description = channelConfig.coupon_description;
      } else if (this.woerma_coupon_description_control == 1) {
        // 个性化 从账号配置获取
        this.coupon_description = accountConfig.coupon_description;
      }
    }
  }
};